import script from "./ForgetThePassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetThePassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgetThePassword.vue?vue&type=style&index=0&id=6b5668e6&lang=css"
import "./ForgetThePassword.vue?vue&type=style&index=1&id=6b5668e6&lang=scss&scoped=scoped"

import exportComponent from "C:\\Users\\23586\\Desktop\\美国站\\h5\\us-station-number\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b5668e6"]])

export default __exports__